
export enum FileType {
    None = 0,
    PDF = 1 << 0,
    CSV = 1 << 1,
    Word = 1 << 2,
    JPG = 1 << 3,
    PNG = 1 << 4,
}
